import Moment from 'moment';

type SupportedLocale = 'en-au' | 'en-gb' | 'en-us' |'en';

const LOCALE_DATE_FORMATS: Record<SupportedLocale, string> = {
  'en-au': 'DD/MM/YYYY',
  'en-gb': 'DD/MM/YYYY',
  'en-us': 'MM/DD/YYYY',
  en: 'MM/DD/YYYY',
};

const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';

let cachedFormat: string | null = null;

export const getDateFormatForLocale = (): string => {
  if (cachedFormat) {
    return cachedFormat;
  }

  const momentLocale = Moment.locale();
  const locale = momentLocale.toLowerCase() as SupportedLocale;

  cachedFormat = LOCALE_DATE_FORMATS[locale] || DEFAULT_DATE_FORMAT;
  return cachedFormat;
};

export const formatDateForLocale = (date: Date): string => {
  return Moment(date).format(getDateFormatForLocale());
};

export const clearDateFormatCache = (): void => {
  cachedFormat = null;
};
